/**
 * transcribeAudio - Helper function to transcribe audio using OpenAI Whisper API
 * Works with the existing OpenAI proxy for authentication
 */
import { uiLogger } from '@annote/core/utils/debug';

const fastApiUrl = import.meta.env.VITE_FASTAPI_URL || 'http://localhost:3013';
const functionsUrl = import.meta.env.VITE_SUPABASE_FUNCTIONS_URL;

export interface TranscriptionResult {
  text: string;
  error?: string;
}

export const transcribeAudio = async (
  audioBlob: Blob,
  customFetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>,
): Promise<TranscriptionResult> => {
  const baseUrl = fastApiUrl ? `${fastApiUrl}/ai/openai-proxy` : `${functionsUrl}/openai-proxy`;

  try {
    const formData = new FormData();
    formData.append('file', audioBlob, 'audio.webm');
    formData.append('model', 'whisper-1');

    const response = await customFetch(`${baseUrl}/audio/transcriptions`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Transcription failed: ${response.status} ${errorText}`);
    }

    const result = await response.json();
    return { text: result.text };
  } catch (error) {
    uiLogger.error('Error transcribing audio:', error);
    return {
      text: '',
      error: error instanceof Error ? error.message : 'Unknown error occurred during transcription',
    };
  }
};
